module.exports = __webpack_public_path__ + "static/media/anand.5fe5f239.png";